import React, { useEffect, useState } from 'react';
import { Menu, Dropdown, DropDownProps } from 'antd';
import styled from 'styled-components';
import { renderActionMenuItems } from './render-actions-menu-items';
import './styles.css';
import { useClickedOutside } from '../../../hooks';

const directionMap = {
	horizontal: 'row',
	vertical: 'column'
};

export const emptyOptions = {
	DISABLED: 'disabled',
	HIDDEN: 'hidden'
};

interface IMenuDots {
	visible?: boolean;
	bordered?: boolean;
	active?: boolean;
	disabled?: boolean;
	direction?: keyof typeof directionMap;
}

const MenuDots = styled.div<IMenuDots>`
	@media (hover: hover) {
		display: ${({ visible }) => (visible ? 'flex' : 'none')};
		flex-direction: ${({ direction }) => (direction ? directionMap[direction] : 'column')};
		background-color: ${({ bordered, active }) =>
			bordered && active ? 'rgb(23, 43, 77)' : bordered ? 'rgba(0, 0, 0, 0.08)' : 'transparent'};
	}
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: center;
	margin-right: 15px;
	width: ${({ direction, bordered }) => (direction === 'horizontal' || bordered ? '30px' : '0')};
	position: relative;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed !important' : 'pointer')};
	height: 30px;
	// height: ${({ direction }) => (direction === 'horizontal' ? '30px' : 'auto')};
	padding: ${({ direction }) => (direction === 'horizontal' ? '0 3px' : 'revert')};

	.dot {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: ${({ active, bordered }) =>
			active && !bordered ? ({ theme }) => theme.TA_GREEN : active && bordered ? '#fff' : '#888'};
		/* margin-top: 4px; */
	}

	&:hover {
		background-color: ${({ bordered, active }) =>
			active && bordered ? 'rgb(23, 43, 77)' : bordered ? 'rgba(0,0,0,.15)' : 'transparent'};
	}
	&:hover .dot {
		background-color: ${({ bordered, active }) =>
			active && bordered ? '#fff' : bordered ? 'rgba(0,0,0,.35)' : ({ theme }) => theme.TA_GREEN};
	}
`;
interface IActionsMenu {
	options: any;
	dotsOrientation?: 'vertical' | 'horizontal';
	dotsStyle?: any;
	bordered?: boolean;
	dotsVisible?: boolean;
	whenEmpty?: string;
}
const ActionsMenu: React.FC<IActionsMenu> = ({
	options,
	dotsOrientation,
	dotsStyle,
	bordered = false,
	dotsVisible = true,
	whenEmpty = 'hidden'
}) => {
	const { ref, isComponentVisible, setIsComponentVisible } = useClickedOutside(false);
	const [menuDotsDisabled, setMenuDotsDisabled] = useState(false);
	useEffect(() => setMenuDotsDisabled(options.length ? false : true), [options.length]);
	const switchMenu = e => {
		if (e.domEvent) e.domEvent.stopPropagation();
		else e.stopPropagation();
		if (!menuDotsDisabled) setIsComponentVisible(!isComponentVisible);
	};

	return whenEmpty === emptyOptions.HIDDEN && menuDotsDisabled ? null : (
		<Dropdown
			placement="bottomRight"
			overlay={
				<Menu onClick={switchMenu} style={{ width: 'max-content' }} mode="vertical" className="p-0">
					{renderActionMenuItems(options)}
				</Menu>
			}
			getPopupContainer={s => {
				ref.current = s;
				return s;
			}}
			disabled={whenEmpty === emptyOptions.DISABLED && menuDotsDisabled}
			visible={dotsVisible && isComponentVisible}
		>
			<MenuDots
				visible={dotsVisible}
				direction={dotsOrientation}
				style={{ ...dotsStyle }}
				bordered={bordered}
				active={isComponentVisible}
				onClick={switchMenu}
			>
				<div className="dot"></div>
				<div className="dot"></div>
				<div className="dot"></div>
			</MenuDots>
		</Dropdown>
	);
};

export default ActionsMenu;
